import { render, staticRenderFns } from "./WordSlimLayout.vue?vue&type=template&id=c390bf7c&scoped=true&"
import script from "./WordSlimLayout.vue?vue&type=script&lang=js&"
export * from "./WordSlimLayout.vue?vue&type=script&lang=js&"
import style0 from "./WordSlimLayout.vue?vue&type=style&index=0&id=c390bf7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c390bf7c",
  null
  
)

export default component.exports